import { render } from "./CustomerAfterSales.vue?vue&type=template&id=4baad752&scoped=true"
import script from "./CustomerAfterSales.vue?vue&type=script&lang=js"
export * from "./CustomerAfterSales.vue?vue&type=script&lang=js"

import "./CustomerAfterSales.vue?vue&type=style&index=0&id=4baad752&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4baad752"]])

export default __exports__